import React from 'react'
import { Link } from 'react-static'
//
export default () => {
    const today = new Date();
    const year = today.getFullYear();
    return (
        <div className="footer">
            <div className="container">
                <div className="grid grid--full grid--center">
                    <div className="grid__cell grid__cell--6-12@sm">
                        <h4>Contact us  <a className="underline" href="/contact/#sydney">Sydney</a><a className="underline" href="/contact/#singapore">Singapore</a></h4>
                    </div>
                    <div className="grid__cell grid__cell--6-12@sm">
                        <div className="footer__right">
                            <span className="footer__social">
                                <a className="underline" target="_blank" href="https://www.instagram.com/ward6sg/">Instagram</a>
                                <a className="underline" target="_blank" href="https://www.facebook.com/Ward6Singapore/">Facebook</a>
                                <a className="underline" target="_blank" href="https://www.linkedin.com/company/ward6-singapore/">Linkedin</a>
                            </span>
                            <span className="footer__privacy"><Link to="/privacy" className="underline">Privacy</Link> <span>&copy; Ward6 {year}</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer.js